import request from '@/utils/request'

// 首页轮播图（app_home_banner）

export interface AppHomeBanner {
  id?: number
  title?: string
  imageUrl: string
  linkUrl?: string
  status?: number
  storeId?: number | null
  sort?: number
}

export const getHomeBannerList = (params: { storeId?: number; status?: number }) => {
  return request({
    url: '/homeBanner/list',
    method: 'get',
    params
  })
}

export const createHomeBanner = (data: AppHomeBanner) => {
  return request({
    url: '/homeBanner',
    method: 'post',
    data
  })
}

export const updateHomeBanner = (data: AppHomeBanner) => {
  return request({
    url: '/homeBanner',
    method: 'put',
    data
  })
}

export const deleteHomeBanner = (id: number) => {
  return request({
    url: `/homeBanner/${id}`,
    method: 'delete'
  })
}

export const homeBannerMoveSort = (params: { id: number | string; direction: 'up' | 'down' }) => {
  return request({
    url: `/homeBanner/sort/${params.direction}`,
    method: 'post',
    params: { id: params.id }
  })
}

export const homeBannerSetSort = (params: { id: number | string; sort: number }) => {
  return request({
    url: `/homeBanner/sort`,
    method: 'post',
    params: { id: params.id, sort: params.sort }
  })
}
